export default __webpack_public_path__ + "static/media/putri.86dec382.png";